<meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
<meta http-equiv="Pragma" content="no-cache">
<meta http-equiv="Expires" content="0">
<div class="report-outlet-div">
    <div class="form-group row marginRight">
        <div class="col-sm-3 reportSpan">
            <span class="">UI Report</span>
        </div>
        <div class="col-sm-12 table-responsive">
            <table class="table" sortable-table >
                <thead>
                    <tr>
                        <th pm-sortable-column="userId">User ID</th>
                        <th pm-sortable-column="uploadDate">Upload Date</th>
                        <th pm-sortable-column="fileName">File Name</th>
                        <th pm-sortable-column="fileSize">File Size</th>
                        <th pm-sortable-column="globalStatus">Global Status</th>
                        <th pm-sortable-column="totalLineCount">Total line count</th>
                        <th pm-sortable-column="processingEndDate">End of Processing Date</th>
                        <th pm-sortable-column="successResult">Success Result</th>
                        <th pm-sortable-column="failureResult">Failure Result</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let eachrecord of report">
                        <td>{{eachrecord.userId}}</td>
                            <td>{{dateOf(eachrecord.uploadDate) | date : 'YYYY-MM-dd HH:mm:ss' }}</td>
                           <td>
                           <a class="alertLink" (click)="getDownload(eachrecord.id,eachrecord.fileName)">
                             <span ng-bind="eachrecord.fileName"></span>{{eachrecord.fileName}}</a>
                           </td>
                            <td>{{eachrecord.fileSize}}</td>
                            <td>{{eachrecord.globalStatus}}</td>
                            <td>{{eachrecord.totalLinesCount}}</td>
                            <td>{{(eachrecord.processingEndDate !== null) ? (dateOf(eachrecord.processingEndDate) | date : 'YYYY-MM-dd HH:mm:ss' : "") : "" }}</td>
                            <td>
                                 <a class="alertLink" (click)="getReport(eachrecord.id,'Success',eachrecord.successReportName)">{{eachrecord.successReportName}}</a>
                             </td>
                        <td>
                            <a class="alertLink" (click)="getReport(eachrecord.id,'Failure',eachrecord.failureReportName)">{{eachrecord.failureReportName}}</a>
                        </td>
                    </tr>
                    <tr *ngIf="report?.length < 1">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    <td></td>
                    <td></td>

                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">
            <div class="col-sm-4 paginationDiv" *ngIf="report.totalRecords>10">
                    <ul class="pagination">
                            <li class="page-item" [class.disabled]="PreviousClick(pageNumber)"><a class="page-link" (click)="previousClickAction(pageNumber)">Previous</a></li>
                            <li class="page-item" *ngFor="let number of pageNumber; let i = index" [attr.data-index]="i"><a class="page-link" [ngClass]="{'active-anchor': number===returnPageNum()}" id="page-num-{{i+1}}" (click)="loadReport($event,number)">{{number}}</a></li>
                            <li class="page-item" [class.disabled]="NextClick(pageNumber)"><a class="page-link" (click)="nextClickAction(pageNumber)">Next</a></li>
                          </ul>
                        </div>

</div>
</div>
<div class="footer">
    <p class="padding-bottom">Allianz @copyright. All rights reserved</p>
</div>
